import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconStop = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <circle cx="10" cy="10" r="9.25" stroke="currentColor" strokeWidth="1.5" />
      <rect x="6" y="6" width="8" height="8" fill="currentColor" />
    </svg>
  )
}

export default IconStop
